
import React, { useEffect, useState } from "react";
import { Navbar, Nav, Offcanvas, Button, Collapse, OverlayTrigger, Tooltip, Col, Container, Row } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/sidebar.css";
import Template from "../../layout/Template";
import { useLocation, useNavigate } from "react-router-dom";

export default function ConfiguracoesSistemaPrincipal({ children, cliente }) {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showMobile, setShowMobile] = useState(false);
    const [openUsuarios, setOpenUsuarios] = useState(false);
    const [openConfig, setOpenConfig] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    const [contentMenu, setContentMenu] = useState()
    const [contentSubMenu, setSubContentMenu] = useState()

    const location = useLocation();
    const currentPath = location.pathname;
    const navigate = useNavigate()


    const handleSelectOpcao = (e) => {
        navigate(e.target.value)
    }

    useEffect(() => {
        let path = currentPath.split('/')
        setContentMenu(path[2])
        setSubContentMenu(path[2])
        switch (path[2]) {
            case 'usuarios':
            case 'gruposUsuarios':
                setContentMenu('usuarios')
                setOpenUsuarios(true)

                break;
        }
        if (path[3] != undefined) {
            setSubContentMenu(path[3])
        }
       console.log(path)

    }, [])

    const menuItems = [
        {
            icon: "",
            label: "Empresa",
            link: "/admin/configuracoes/empresas",
            content: "empresas"
        },
        {
            icon: "",
            label: "Configs. de Usuários",
            link: "/admin/configuracoes/usuarios",
            content: "usuarios",
            submenu: [
                { label: "Usuários", link: "/admin/configuracoes/usuarios", content: "usuarios" },
                { label: "Grupos de usuários", link: "/admin/configuracoes/gruposUsuarios", content: "gruposUsuarios" },
            ],
            open: openUsuarios,
            toggle: () => setOpenUsuarios(!openUsuarios),
        },
        {
            icon: "",
            label: "Serviços",
            link: "/admin/configuracoes/servicos",
            content: "servicos"
        },
        {
            icon: "",
            label: "Agenda Online",
            link: "/admin/configuracoes/agendaOnline",
            content: "agendaOnline"
        },

        /*   {
               icon: "⚙",
               label: "Configurações",
               submenu: [
                   { label: "Usuários", link: "#usuarios" },
                   { label: "Permissões", link: "#permissoes" },
               ],
               open: openConfig,
               toggle: () => setOpenConfig(!openConfig),
           },
           {
               icon: "📊",
               label: "Relatórios",
               link: "#relatorios",
           },*/
    ];

    const carregaConteudo = () => {
        return
    }

    console.log(contentMenu)
    return (

        <Template>



            <div className="d-flex" id="container-interno">
                {/* Sidebar desktop */}
                <div id="sidebar"
                    className="d-none d-lg-flex flex-column"
                    style={{
                        width: sidebarOpen ? "220px" : "70px",
                        minHeight: "100vh",
                        transition: "width 0.3s ease",
                        overflowX: "hidden",
                    }}
                >
                    {/* Botão de toggle */}
                    <div className="p-2 border-bottom border-secondary">
                        <h5 className="text-primary text-center">Configs.  do sistema</h5>
                        {/*<Button variant="link" className="text-white" onClick={toggleSidebar}>
                        {sidebarOpen ? "⬅" : "➡"}
                    </Button>*/}
                    </div>

                    <Nav className="flex-column" >
                        {menuItems.map((item, idx) => (
                            <div key={idx}>
                                {item.submenu ? (
                                    <>
                                        <OverlayTrigger
                                            placement="right"
                                            overlay={!sidebarOpen ? <Tooltip>{item.label}</Tooltip> : <></>}
                                        >
                                            <Button
                                                className={(contentMenu == item.content) ? 'selected  text-start w-100' : ' text-start w-100'}
                                                variant="link"
                                                onClick={item.toggle}
                                            >
                                                {item.icon} {sidebarOpen && item.label}
                                            </Button>
                                        </OverlayTrigger>

                                        <Collapse in={item.open} style={{ 'marginTop': '6px' }}>
                                            <div className="ps-4">
                                                {item.submenu.map((sub, sIdx) => (
                                                    <Nav.Link key={sIdx} href={sub.link}
                                                        className={(contentSubMenu == sub.content) ? 'selected  text-white-50' : ' text-white-50'}
                                                        onClick={() => setContentMenu(sub.content)}>
                                                        {sidebarOpen && sub.label}
                                                    </Nav.Link>
                                                ))}
                                            </div>
                                        </Collapse>
                                    </>
                                ) : (
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={!sidebarOpen ? <Tooltip>{item.label}</Tooltip> : <></>}
                                    >
                                        <Nav.Link href={item.link} className={(contentMenu == item.content) ? 'selected' : ''} onClick={() => setContentMenu(item.content)}>
                                            {item.icon} {sidebarOpen && item.label}
                                        </Nav.Link>
                                    </OverlayTrigger>
                                )}
                            </div>
                        ))}
                    </Nav>
                </div>

                {/* Navbar Mobile 
                <Navbar bg="" variant="" expand={false} className="d-lg-none w-100">
                    <Button variant="info" onClick={() => setShowMobile(true)}>
                        ☰ Menu
                    </Button>
                </Navbar>*/}

                {/* Offcanvas Mobile */}
                <Offcanvas show={showMobile} onHide={() => setShowMobile(false)} id="menu-mobile">
                    <Offcanvas.Header closeButton closeVariant="white">
                        <Offcanvas.Title>Menu</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="flex-column">
                            {menuItems.map((item, idx) => (
                                <div key={idx}>
                                    {item.submenu ? (
                                        <>
                                            <Button
                                                variant="link"
                                                className="text-white text-start w-100"
                                                onClick={item.toggle}
                                            >
                                                {item.icon} {item.label}
                                            </Button>
                                            <Collapse in={item.open}>
                                                <div className="ps-4">
                                                    {item.submenu.map((sub, sIdx) => (
                                                        <Nav.Link key={sIdx} href={sub.link} className="text-white-50" onClick={() => { setContentMenu(sub.content); setShowMobile(false) }}>
                                                            {sub.label}
                                                        </Nav.Link>
                                                    ))}
                                                </div>
                                            </Collapse>
                                        </>
                                    ) : (
                                        <Nav.Link href={item.link} className="text-white" onClick={() => { setContentMenu(item.content); setShowMobile(false) }}>
                                            {item.icon} {item.label}
                                        </Nav.Link>
                                    )}
                                </div>
                            ))}
                        </Nav>
                    </Offcanvas.Body>
                </Offcanvas>



                {/* Conteúdo principal */}
                <div className="flex-grow-1 " style={{ padding: '0px 0px 10px' }}>
                    { /*   <Container fluid id="cliente-header">
                        <Row>

                        </Row>
                        <Row>
                            <Col>
                                <span>Você está visualizando a ficha de </span>
                              </span>
                            </Col>
                        </Row>

                    </Container>  */}

                    <div className="d-lg-none w-100 box-fundo mb-15">
                        <h4>Configurações do sistema</h4>

                        <label className="mb-10">  Selecione a opção:</label>
                        <select className="form-control form-select" onChange={(e) => handleSelectOpcao(e)}>
                            <option value="">Selecione...</option>
                            {menuItems?.map((item) => (
                                <>
                            
                                    {(item?.submenu) ? (
                                        
                                        <optgroup label={item.label}>
                                            
                                            {(item?.submenu.map((sub) => (
                                                
                                                <option value={sub.link} selected={(contentSubMenu == sub.content)?'selected':''} >{sub.label}</option>
                                            )))}


                                        </optgroup>)
                                        :
                                        (<option value={item.link} selected={(contentMenu == item.content)?'selected':''} >{item.label}</option>)}
                                </>



                            ))}
                        </select>
                    </div>

                    <div id="divContent-sidebar" className="box-fundo">
                        {children}
                    </div>

                </div>
            </div>
        </Template>
    );
}
